import { api } from "common";

export const NOTIFICATION_URL = {
	getNotifications:`${api.withAPI}api/notification`,
	getNotification: `${api.withAPI}api/notification`,
	readNotifications: `${api.withAPI}api/notification/read`
}